module.exports = __webpack_public_path__ + "img/Hollowed-Boxes.dafeafc3.svg";